'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var redux = require('redux');
var _regeneratorRuntime = _interopDefault(require('regenerator-runtime'));
var Route = _interopDefault(require('houkou'));
var uniqueId = _interopDefault(require('mini-unique-id'));
var thunkMiddleware = _interopDefault(require('redux-thunk'));
var reactDom = require('react-dom');
var reactRedux = require('react-redux');
var React = require('react');
var React__default = _interopDefault(React);
var debounce = _interopDefault(require('debounce'));
var PropTypes = _interopDefault(require('prop-types'));
var toCSS = _interopDefault(require('style-to-css'));

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();

var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

// sorting mechanism for matched candidates
var FORWARD_SLASHES_REGEX = /\//g;
var complexity = function complexity(pattern) {
  return pattern.match(FORWARD_SLASHES_REGEX).length;
};
function compare(a, b) {
  return complexity(b.pattern) - complexity(a.pattern);
}

// cache the app's patterns as routes ready to be matched
var getPatterns = function getPatterns(lookup) {
  return lookup.map(function (def) {
    var _ref = typeof def === 'string' ? { pattern: def } : def,
        pattern = _ref.pattern,
        config = objectWithoutProperties(_ref, ['pattern']);

    return {
      pattern: pattern,
      route: new Route(pattern, config)
    };
  });
};

// define a matcher in case we need to work with a dynamic panel
var match = function match(path, lookup) {
  return getPatterns(lookup).map(function (_ref2) {
    var pattern = _ref2.pattern,
        route = _ref2.route;

    var params = route.match(path);

    if (params) {
      return {
        params: params,
        pattern: pattern
      };
    } else {
      return false;
    }
  }).filter(Boolean).sort(compare)[0];
};

function createFindPanel(panels) {
  var lookup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  // return our grand matcher
  return function findPanel(path) {
    // the panel might be static...
    var panel = panels[path];
    var props = void 0;

    // TODO is there any case in which the panel's function should always be called if it's a
    // dynamic match?
    if (typeof panel === 'undefined') {
      // ...or dynamic
      var matchedPath = match(path, lookup);

      if (matchedPath) {
        panel = panels[matchedPath.pattern];
        props = matchedPath.params;
      }
    } else {
      props = panel.props || {};
    }

    return {
      panel: panel,
      props: props
    };
  };
}

function isRequireable(dep) {
  var is = false;

  try {
    require(dep);
    is = true;
  } catch (err) {}

  return is;
}

// Original source [partition-bundle](https://github.com/arian/partition-bundle/blob/master/lib/loadScript.js)
function load(file) {
  var _this = this;

  return new Promise(function (resolve, reject) {
    if (typeof file === 'undefined') {
      return resolve();
    }

    var resource = document.createElement('script');
    var done = false;

    function ready(err) {
      done = true;
      resource.onload = resource.onerror = resource.onreadystatechange = null;
      clearTimeout(timer);
      err ? reject(err) : resolve();
    }

    resource.onload = resource.onreadystatechange = function (e) {
      if (!(done && (!_this.readyState || _this.readyState === 'complete' || _this.readyState === 'loaded'))) {
        ready(null);
      }
    };

    resource.onerror = function (error) {
      if (!done) {
        ready(error || new Error('Could not load file'));
      }
    };

    var timer = setTimeout(function () {
      ready(new Error('Resource ' + file + ' loading timed-out'));
    }, 3e4);

    resource.src = file;
    document.getElementsByTagName('head')[0].appendChild(resource);
  });
}

var loadModule = function () {
  var _ref = asyncToGenerator(_regeneratorRuntime.mark(function _callee(app) {
    var module, response, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            module = {};
            _context.prev = 1;
            _context.next = 4;
            return fetch('//' + app + '/panels.json');

          case 4:
            response = _context.sent;
            _context.next = 7;
            return response.json();

          case 7:
            data = _context.sent;


            if (data.module) {
              module = data.module;
            }

            _context.next = 11;
            return load(data.logic);

          case 11:
            _context.next = 18;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context['catch'](1);

            console.error(_context.t0);

            if (!(_context.t0 instanceof SyntaxError)) {
              _context.next = 18;
              break;
            }

            throw new Error('We can\'t load ' + app + '.\n        We can\'t find your app\'s logic source.\n\n        If you\'re inlining your app with Panels, make sure the script tag is inserted after panels\n        and that the required export matches ' + app + '.\n\n        If your app is expected to be fetched from a remote source, make sure that\n        \'//' + app + '/panels.json\' in place and that it at least includes the logic key pointing to\n        your application\'s JS logic URI.\n\n        {\n          "logic": "https://panels.com/my-application-logic.js"\n        }');

          case 18:
            return _context.abrupt('return', module);

          case 19:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[1, 13]]);
  }));

  return function loadModule(_x) {
    return _ref.apply(this, arguments);
  };
}();

var DENY = function DENY() {
  return false;
};

var getApp = (function () {
  var _ref2 = asyncToGenerator(_regeneratorRuntime.mark(function _callee2(app, createContext) {
    var data, name, props, inline, _require, _require$access, access, notify, lookup, panels, setup, types, context;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            data = void 0;
            name = app;
            props = {};

            if (isRequireable(name)) {
              _context2.next = 12;
              break;
            }

            inline = window.panelsJson && window.panelsJson[name];

            if (inline) {
              data = inline.module;

              if (!isRequireable(data.name)) {
                console.error('You should embed your app\'s panels bundle script tag');
              }
            }

            if (data) {
              _context2.next = 10;
              break;
            }

            _context2.next = 9;
            return loadModule(app);

          case 9:
            data = _context2.sent;

          case 10:

            if (data.name) {
              name = data.name;
            }
            if (data.props) {
              props = data.props;
            }

          case 12:

            /* eslint-disable global-require */
            _require = require(name), _require$access = _require.access, access = _require$access === undefined ? DENY : _require$access, notify = _require.notify, lookup = _require.lookup, panels = _require.panels, setup = _require.setup, types = _require.types;
            context = createContext(app, name);
            _context2.t0 = access;
            _context2.t1 = createFindPanel(panels, lookup);
            _context2.t2 = name;
            _context2.t3 = notify;
            _context2.t4 = typeof setup === 'function';

            if (!_context2.t4) {
              _context2.next = 23;
              break;
            }

            _context2.next = 22;
            return setup(app, props, context);

          case 22:
            _context2.t4 = _context2.sent;

          case 23:
            _context2.t5 = _context2.t4;
            _context2.t6 = types;
            return _context2.abrupt('return', {
              access: _context2.t0,
              findPanel: _context2.t1,
              name: _context2.t2,
              notify: _context2.t3,
              store: _context2.t5,
              types: _context2.t6
            });

          case 26:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  function get(_x2, _x3) {
    return _ref2.apply(this, arguments);
  }

  return get;
})();

function getContextAndFocus(_ref) {
  var currentFocus = _ref.currentFocus,
      next = _ref.next,
      last = _ref.last;

  // focus works in relation to the currentFocus, so try to do what the user wants
  var focus = currentFocus + next.focus;
  if (focus < 0 || focus > last) {
    // however, they may go out of boundaries in such cases we default to the last route
    focus = last;
  }

  // context works in relation to the new focus, so try to do what the user wants,
  // it tells how many panels we should preferably show before the focus.
  // we say preferably because it might be the case that it isn't possible to fit them all in the
  // current viewport
  var context = 0;
  if (typeof next.context === 'number') {
    context = focus - next.context;

    if (context < 0 || context > focus) {
      // if the value is out of boundaries, default to showing all
      context = 0;
    }
  }

  return {
    context: context,
    focus: focus
  };
}

function getIndexOfPanelToShow(at, regions) {
  var index = regions.findIndex(function (region) {
    return at < region;
  });
  return index === -1 ? regions.length - 1 : index;
}

function getNextPosition(_ref) {
  var context = _ref.context,
      focus = _ref.focus,
      maxFullPanelWidth = _ref.maxFullPanelWidth,
      routes = _ref.routes,
      panels = _ref.panels,
      shouldGoMobile = _ref.shouldGoMobile,
      viewportWidth = _ref.viewportWidth;

  var nextRoutesByContext = routes.byContext;

  var widths = routes.items.map(function (routeContext) {
    var route = routes.byContext[routeContext];
    var panel = panels.byId[route.panelId];

    var width = void 0;
    if (route.isVisible) {
      if (shouldGoMobile) {
        width = viewportWidth;
      } else {
        width = route.isExpanded ? panel.maxWidth : panel.width;

        var percentageMatch = typeof width === 'string' && width.match(/([0-9]+)%/);
        if (percentageMatch) {
          width = maxFullPanelWidth * parseInt(percentageMatch, 10) / 100;
        }
      }
    } else {
      width = 0;
    }

    if (width !== route.width) {
      nextRoutesByContext = _extends({}, nextRoutesByContext, defineProperty({}, routeContext, _extends({}, route, {
        width: width
      })));
    }

    return width;
  });

  // get how large our focus panel is
  var focusWidth = widths[focus]; // >> 500
  // get the focus panel's x real position in our runtime if it were flat
  var x = widths.slice(0, focus).reduce(function (a, b) {
    return a + b;
  }, 0); // >> 860
  // get how much space we have left for context panels
  var leftForContext = maxFullPanelWidth - focusWidth; // >> 1089
  // assess how many context panels we should try to show
  var contextsLeft = focus - context - 1;

  // try to fit those context panels within that space that's left
  while (contextsLeft >= 0 && leftForContext >= widths[contextsLeft]) {
    // get the context's width
    var contextWidth = widths[contextsLeft];
    // remove it from the space left for context
    leftForContext -= contextWidth;
    // shift x to include that panel
    x -= contextWidth;
    // decrease the amount of contexts left
    contextsLeft--;
  }

  return {
    routesByContext: nextRoutesByContext,
    x: x,
    width: maxFullPanelWidth + widths.reduce(function (a, b) {
      return a + b;
    }, 0),
    widths: widths
  };
}

function getHalves(widths) {
  var halves = [];

  widths.forEach(function (width) {
    var half = width / 2;

    halves.push(half);
    halves.push(half);
  });

  return halves;
}

var sum = (function (a, b) {
  return a + b;
});

function getRegions(widths) {
  var halves = getHalves(widths);

  return widths.map(function (_, i) {
    var to = i * 2 + 1;
    return halves.slice(0, to).reduce(sum, 0);
  });
}

// original src: https://github.com/substack/path-browserify
function normaliseArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// original src: https://github.com/substack/path-browserify
function normalisePath(rawPath) {
  var isAbsolute = rawPath.charAt(0) === '/';
  var trailingSlash = rawPath.substr(-1) === '/';

  // normalise the path
  var path = normaliseArray(rawPath.split('/').filter(function (p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
}

var TRAILING_SLASH_REGEX = /\/$/;

function withTrailingSlash(uri) {
  return TRAILING_SLASH_REGEX.test(uri) ? uri : uri + "/";
}

var decodeSchema = function decodeSchema(s) {
  return s.replace(/<<HTTP>>/g, 'http://').replace(/<<HTTPS>>/g, 'https://');
};
var encodeSchema = function encodeSchema(s) {
  return s.replace(/http:\/\//g, '<<HTTP>>').replace(/https:\/\//g, '<<HTTPS>>');
};

var normaliseUri = (function (uri) {
  return decodeSchema(normalisePath(withTrailingSlash(encodeSchema(uri))));
});

var TRAILING_SLASH_REGEX$1 = /\/$/;

var withTrailingSlash$1 = (function (uri) {
  return TRAILING_SLASH_REGEX$1.test(uri) ? uri : uri + "/";
});

var DEFAULT_PARSER = /^https?:\/\/([a-zA-Z0-9\-_.]+)()(\/.*)/;
var PROTOCOL = /(https?):\/\//;
var SLICE_END = ')';
var SLICE_START = '(';
var SLICE_MARKERS = new RegExp('[' + SLICE_START + SLICE_END + ']', 'g');

// TODO review this, instead of discarding the query string perhaps we can pass it down to
// the last panel?
var withoutQueryString = function withoutQueryString(s) {
  return (/\?/.test(s) ? s.match(/(.*?)\?/)[1] : s
  );
};

var MANY_APPS = /^(https?:\/\/.+?\/)(https?:\/\/.+)/;

var appSplit = function appSplit(s) {
  var currentUri = s;
  var nextUri = false;

  var manyAppsMatch = s.match(MANY_APPS);
  if (manyAppsMatch) {
    currentUri = manyAppsMatch[1];
    nextUri = manyAppsMatch[2];
  }

  return {
    currentUri: currentUri,
    nextUri: nextUri
  };
};

function parse(uri) {
  var parsers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var apps = {
    byName: {},
    items: []
  };
  var routes = {
    byContext: {},
    items: []

    // Make sure we always have a trailing slash on the URI
  };var protocol = uri.match(PROTOCOL)[1];
  var nextUri = withoutQueryString(withTrailingSlash$1(uri));

  var _loop = function _loop() {
    var split = appSplit(nextUri);
    var currentUri = split.currentUri;
    nextUri = split.nextUri;

    var parser = parsers.find(function (p) {
      return p.test(currentUri);
    }) || DEFAULT_PARSER;

    var _currentUri$match = currentUri.match(parser),
        _currentUri$match2 = slicedToArray(_currentUri$match, 4),
        _0 = _currentUri$match2[0],
        app = _currentUri$match2[1],
        _1 = _currentUri$match2[2],
        path = _currentUri$match2[3];

    var base = protocol + '://' + app;
    var context = routes.items.length > 0 ? routes.items[routes.items.length - 1] : '';

    // Get every path 'bit' which is indeed every panel we need to load
    var pathRoute = [];
    var isVisible = true;
    do {
      path = path.split('/');
      var lastBit = path.length > 1 ? path[path.length - 2] : '';
      path = path.slice(0, path.length - 1).join('/');
      var hasSliceEndMarkerForRoot = lastBit.indexOf(SLICE_END) === 0;
      var hasSliceEndMarker = !hasSliceEndMarkerForRoot && lastBit.indexOf(SLICE_END) > -1;
      var hasSliceStartMarker = lastBit.indexOf(SLICE_START) > -1;

      if (hasSliceEndMarker || hasSliceStartMarker) {
        isVisible = false;
      }

      var panelPath = path.replace(SLICE_MARKERS, '') || '/';

      var panelId = '' + app + panelPath;

      pathRoute.push({
        app: app,
        context: '' + context + base + withTrailingSlash$1(path),
        isVisible: isVisible,
        panelId: panelId,
        path: panelPath
      });

      isVisible = hasSliceEndMarkerForRoot ? false : hasSliceStartMarker ? true : isVisible;
    } while (path.length);

    if (apps.items.indexOf(app) === -1) {
      apps.items.push(app);
      apps.byName[app] = {
        app: app,
        panels: []
      };
    }

    pathRoute.reverse().forEach(function (route) {
      routes.byContext[route.context] = route;
      routes.items.push(route.context);

      if (apps.byName[app].panels.indexOf(route.path) === -1) {
        apps.byName[app].panels.push(route.path);
      }
    });
  };

  do {
    _loop();
  } while (nextUri);

  return {
    apps: apps,
    routes: routes
  };
}

function ensurePanelShape(panel) {
  if (typeof panel.width === 'undefined') {
    panel.width = 360;
  }
}

var NAVIGATE = 'panels/NAVIGATE';
function navigate(rawUri) {
  var nextFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var nextContext = arguments[2];

  return function () {
    var _ref = asyncToGenerator(_regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var _this = this;

      var _getState, apps, panels, router, runtime, uri, parsed, routes, createAppContext, nextApps, nextPanels, maxFullPanelWidth, isFirstLoad, last, opts, focusRoute, focusPanel, _getContextAndFocus, context, focus, widths, focusWidth, x, leftForContext, contextsLeft, contextWidth, regions, snappedAt;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _getState = getState(), apps = _getState.apps, panels = _getState.panels, router = _getState.router, runtime = _getState.runtime;
              uri = normaliseUri(rawUri);

              if (!(uri === router.uri)) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt('return');

            case 4:
              parsed = parse(uri, router.parsers);
              routes = {
                byContext: parsed.routes.byContext,
                items: parsed.routes.items
              };

              createAppContext = function createAppContext(appName, appModule) {
                var access = function () {
                  var _ref2 = asyncToGenerator(_regeneratorRuntime.mark(function _callee(name) {
                    var app;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            app = getState().apps.byName[name];

                            if (!app) {
                              _context.next = 9;
                              break;
                            }

                            if (!app.access(appName, appModule)) {
                              _context.next = 6;
                              break;
                            }

                            return _context.abrupt('return', app.store);

                          case 6:
                            throw Error('Access to ' + name + ' denied.');

                          case 7:
                            _context.next = 10;
                            break;

                          case 9:
                            throw Error('App ' + name + ' doesn\'t exist or it doesn\'t have a store.');

                          case 10:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function access(_x4) {
                    return _ref2.apply(this, arguments);
                  };
                }();

                return {
                  access: access,
                  navigate: function navigate$$() {
                    return dispatch(navigate.apply(undefined, arguments));
                  },
                  routes: routes
                };
              };

              // get the next apps


              nextApps = {
                byName: {},
                items: parsed.apps.items.filter(function (name) {
                  return apps.items.indexOf(name) === -1;
                })
              };


              if (nextApps.items.length) {
                dispatch({
                  type: NAVIGATE,
                  sequence: {
                    type: 'start'
                  },
                  meta: {
                    uri: uri
                  }
                });
              }

              _context3.next = 11;
              return Promise.all(nextApps.items.map(function () {
                var _ref3 = asyncToGenerator(_regeneratorRuntime.mark(function _callee2(name) {
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.prev = 0;
                          _context2.next = 3;
                          return getApp(name, createAppContext);

                        case 3:
                          nextApps.byName[name] = _context2.sent;
                          _context2.next = 9;
                          break;

                        case 6:
                          _context2.prev = 6;
                          _context2.t0 = _context2['catch'](0);

                          // TODO
                          console.error('Can\'t load app ' + name, _context2.t0);

                        case 9:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this, [[0, 6]]);
                }));

                return function (_x5) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 11:
              nextPanels = {
                byId: {},
                items: []

                // we still need to go through all the apps
              };
              parsed.apps.items.forEach(function (name) {
                // get the list of panels to load
                var panelsToLoad = parsed.apps.byName[name].panels;
                // get the app
                var app = nextApps.byName[name] || apps.byName[name];

                panelsToLoad.forEach(function (path) {
                  var panelId = '' + name + path;
                  // exit early if the panel is already loaded
                  if (panels.byId[panelId]) {
                    return;
                  }

                  try {
                    // find the panel within the app
                    var _app$findPanel = app.findPanel(path),
                        panel = _app$findPanel.panel,
                        props = _app$findPanel.props;

                    if (typeof panel === 'function') {
                      panel = panel(props, app.store);
                    } else {
                      panel = _extends({}, panel, {
                        props: props
                      });
                    }

                    // ensure that the panel has a valid shape and defaults
                    ensurePanelShape(panel);

                    nextPanels.byId[panelId] = panel;
                    nextPanels.items.push(panelId);
                  } catch (error) {
                    // TODO
                    console.error('Can\'t load panel ' + panelId, error);
                  }
                });
              });

              maxFullPanelWidth = runtime.viewportWidth - runtime.snapPoint;
              isFirstLoad = typeof router.focus === 'undefined';
              last = parsed.routes.items.length - 1;
              // determine the context and focus panel

              opts = {
                currentFocus: router.focus,
                next: {
                  context: nextContext,
                  focus: nextFocus
                },
                uri: uri,
                last: last
              };

              if (isFirstLoad) {
                focusRoute = parsed.routes.byContext[parsed.routes.items[last]];
                focusPanel = nextPanels.byId[focusRoute.panelId];

                opts.currentFocus = last;
                opts.next.focus = 0;
                if (typeof focusPanel.context !== 'undefined') {
                  opts.next.context = focusPanel.context;
                }
              }
              _getContextAndFocus = getContextAndFocus(opts), context = _getContextAndFocus.context, focus = _getContextAndFocus.focus;
              widths = routes.items.map(function (routeContext) {
                // if (routes.byContext[routeContext]) {
                //   return routes.byContext[routeContext].width
                // }

                var route = routes.byContext[routeContext];
                var panel = panels.byId[route.panelId] || nextPanels.byId[route.panelId];

                var width = void 0;
                if (route.isVisible) {
                  if (runtime.shouldGoMobile) {
                    width = runtime.viewportWidth;
                  } else {
                    var prevRoute = router.routes.byContext[routeContext];
                    width = route.isExpanded ? panel.maxWidth : prevRoute && prevRoute.width || panel.width;

                    var percentageMatch = typeof width === 'string' && width.match(/([0-9]+)%/);
                    if (percentageMatch) {
                      width = maxFullPanelWidth * parseInt(percentageMatch, 10) / 100;
                    }
                  }
                } else {
                  width = 0;
                }

                route.width = width;
                return width;
              });

              // get how large our focus panel is

              focusWidth = widths[focus]; // >> 500
              // get the focus panel's x real position in our runtime if it were flat

              x = widths.slice(0, focus).reduce(function (a, b) {
                return a + b;
              }, 0); // >> 860
              // get how much space we have left for context panels

              leftForContext = maxFullPanelWidth - focusWidth; // >> 1089
              // assess how many context panels we should try to show

              contextsLeft = focus - context;

              // try to fit those context panels within that space that's left

            case 24:
              if (!(contextsLeft > 0)) {
                _context3.next = 33;
                break;
              }

              // decrease the amount of contexts left
              contextsLeft--;

              // get the context's width
              contextWidth = widths[contextsLeft];

              // check if we have space left for this panel to be a visible context panel

              if (!(leftForContext < contextWidth)) {
                _context3.next = 29;
                break;
              }

              return _context3.abrupt('break', 33);

            case 29:

              // if we do, remove it from the space left for context
              leftForContext -= contextWidth;
              // shift x to include that panel
              x -= contextWidth;
              _context3.next = 24;
              break;

            case 33:
              regions = getRegions(widths);
              snappedAt = getIndexOfPanelToShow(x, regions);


              dispatch({
                type: NAVIGATE,
                sequence: {
                  type: 'next'
                },
                payload: {
                  apps: nextApps,
                  panels: nextPanels,
                  router: {
                    context: context,
                    focus: focus,
                    routes: routes,
                    uri: uri
                  },
                  runtime: {
                    maxFullPanelWidth: maxFullPanelWidth,
                    regions: regions,
                    snappedAt: snappedAt,
                    width: maxFullPanelWidth + widths.reduce(function (a, b) {
                      return a + b;
                    }, 0),
                    widths: widths,
                    x: x
                  }
                },
                meta: {
                  uri: uri
                }
              });

            case 36:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function navigateThunk(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return navigateThunk;
  }();
}

var TOGGLE_EXPAND = 'panels/panels/TOGGLE_EXPAND';
function toggleExpand(routeContext) {
  return function toggleExpandThunk(dispatch, getState) {
    var _getState2 = getState(),
        panels = _getState2.panels,
        router = _getState2.router,
        runtime = _getState2.runtime;

    var routes = router.routes;
    var route = routes.byContext[routeContext];

    routes.byContext = _extends({}, routes.byContext, defineProperty({}, routeContext, _extends({}, route, {
      isExpanded: !route.isExpanded
    })));

    var nextPosition = getNextPosition({
      // snap at the expanded position!
      context: router.context, // routeIndex - runtime.snappedAt,
      focus: router.focus, // routeIndex,
      maxFullPanelWidth: runtime.maxFullPanelWidth,
      routes: routes,
      panels: panels,
      shouldGoMobile: runtime.shouldGoMobile,
      viewportWidth: runtime.viewportWidth
    });

    dispatch({
      type: TOGGLE_EXPAND,
      payload: nextPosition
    });
  };
}

var UPDATE_SETTINGS = 'panels/panels/UPDATE_SETTINGS';
function updateSettings(routeContext, _ref4) {
  var maxWidth = _ref4.maxWidth,
      title = _ref4.title,
      styleBackground = _ref4.styleBackground,
      width = _ref4.width;

  return function updateSettingsThunk(dispatch, getState) {
    var _getState3 = getState(),
        panels = _getState3.panels,
        router = _getState3.router,
        runtime = _getState3.runtime;

    var nextPanels = {
      byId: panels.byId,
      items: panels.items
    };

    var route = router.routes.byContext[routeContext];

    if (!route.isVisible) return;

    var panel = _extends({}, nextPanels.byId[route.panelId]);

    if (maxWidth) {
      panel.maxWidth = maxWidth;
    }
    if (title) {
      panel.title = title;
    }
    if (styleBackground) {
      panel.styleBackground = styleBackground;
    }
    if (width) {
      panel.width = width;
    }

    nextPanels.byId = _extends({}, nextPanels.byId, defineProperty({}, route.panelId, panel));

    var nextPosition = void 0;
    if (maxWidth || width) {
      nextPosition = getNextPosition({
        context: router.context,
        focus: router.focus,
        maxFullPanelWidth: runtime.maxFullPanelWidth,
        routes: router.routes,
        panels: nextPanels,
        shouldGoMobile: runtime.shouldGoMobile,
        viewportWidth: runtime.viewportWidth
      });
    }

    dispatch({
      type: UPDATE_SETTINGS,
      payload: {
        nextPanelsById: nextPanels.byId,
        nextPosition: nextPosition
      }
    });
  };
}

var notify = (function (store) {
  return function (next) {
    return function (action) {
      if (action.type === NAVIGATE) {
        var _store$getState = store.getState(),
            apps = _store$getState.apps;

        apps.items.forEach(function (name) {
          var app = apps.byName[name];

          if (typeof app.notify === 'function') {
            app.notify({
              type: 'NAVIGATE',
              payload: {
                uri: action.meta.uri
              }
            });
          }
        });
      }

      return next(action);
    };
  };
});

// redux-promise sequence branch without FSA and with mini-unique-id instead
// of lodash's version
//
// https://github.com/acdlite/redux-promise/blob/sequence/src/index.js
function isPromise(val) {
  return val && typeof val.then === 'function';
}

function promiseMiddleware(_ref) {
  var dispatch = _ref.dispatch;

  return function (next) {
    return function (action) {
      if (isPromise(action.payload)) {
        var sequenceId = uniqueId();

        dispatch(_extends({}, action, {
          payload: undefined,
          sequence: {
            type: 'start',
            id: sequenceId
          }
        }));

        return action.payload.then(function (result) {
          return dispatch(_extends({}, action, {
            payload: result,
            sequence: {
              type: 'next',
              id: sequenceId
            }
          }));
        }, function (error) {
          return dispatch(_extends({}, action, {
            payload: error,
            error: true,
            sequence: {
              type: 'next',
              id: sequenceId
            }
          }));
        });
      }

      return next(action);
    };
  };
}

var MOVE_LEFT = 'panels/runtime/MOVE_LEFT';
function moveLeft() {
  return function moveLeftThunk(dispatch, getState) {
    var _getState = getState(),
        runtime = _getState.runtime;

    if (runtime.snappedAt > 0) {
      var nextSnappedAt = runtime.snappedAt - 1;

      dispatch({
        type: MOVE_LEFT,
        payload: {
          snappedAt: nextSnappedAt,
          x: runtime.x - runtime.widths[nextSnappedAt]
        }
      });
    }
  };
}

var MOVE_TO = 'panels/runtime/MOVE_TO';
var MOBILE_THRESHOLD$1 = 720;

var SET_VIEWPORT_WIDTH = 'panels/runtime/SET_VIEWPORT_WIDTH';
function setViewportWidth(viewportWidth) {
  return function setViewportWidthThunk(dispatch, getState) {
    var _getState3 = getState(),
        panels = _getState3.panels,
        router = _getState3.router,
        runtime = _getState3.runtime;

    var shouldGoMobile = viewportWidth <= MOBILE_THRESHOLD$1;
    var snapPoint = shouldGoMobile ? 0 : runtime.preferredSnapPoint;
    var maxFullPanelWidth = viewportWidth - snapPoint;

    var nextPosition = getNextPosition({
      context: router.context,
      focus: router.focus,
      maxFullPanelWidth: maxFullPanelWidth,
      routes: router.routes,
      panels: panels,
      shouldGoMobile: shouldGoMobile,
      viewportWidth: viewportWidth
    });

    dispatch({
      type: SET_VIEWPORT_WIDTH,
      payload: _extends({
        maxFullPanelWidth: maxFullPanelWidth,
        shouldGoMobile: shouldGoMobile,
        snapPoint: snapPoint,
        viewportWidth: viewportWidth
      }, nextPosition)
    });
  };
}

var SET_X = 'panels/runtime/SET_X';
function setX(fromX) {
  return function setXThunk(dispatch, getState) {
    var _getState4 = getState(),
        runtime = _getState4.runtime;

    var snappedAt = getIndexOfPanelToShow(fromX, runtime.regions);
    var x = runtime.widths.slice(0, snappedAt).reduce(function (a, b) {
      return a + b;
    }, 0);

    if (x === fromX) {
      if (runtime.x !== x) {
        dispatch({
          type: SET_X,
          payload: {
            snappedAt: snappedAt,
            x: x
          }
        });
      }
    } else {
      // TODO fix this horrible hack :) we're using it to snap at the edges
      // we should ideally only be dispatching the second one not x: fromX
      dispatch({
        type: SET_X,
        payload: {
          snappedAt: snappedAt,
          x: fromX
        }
      });

      dispatch({
        type: SET_X,
        payload: {
          snappedAt: snappedAt,
          x: x
        }
      });
    }
  };
}

function getViewportWidth() {
  return Math.max(window.document.documentElement.clientWidth, window.innerWidth || 0);
}

function apps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { byName: {}, items: [] };
  var action = arguments[1];

  if (action.type === NAVIGATE && action.sequence.type === 'next' && action.payload.apps.items.length) {
    return {
      byName: _extends({}, state.byName, action.payload.apps.byName),
      items: [].concat(toConsumableArray(state.items), toConsumableArray(action.payload.apps.items))
    };
  } else {
    return state;
  }
}

function panels() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { byId: {}, items: [] };
  var action = arguments[1];

  if (action.type === NAVIGATE && action.sequence.type === 'next' && action.payload.panels.items.length) {
    return {
      byId: _extends({}, state.byId, action.payload.panels.byId),
      items: [].concat(toConsumableArray(state.items), toConsumableArray(action.payload.panels.items))
    };
  } else if (action.type === UPDATE_SETTINGS) {
    return _extends({}, state, {
      byId: action.payload.nextPanelsById
    });
  } else {
    return state;
  }
}

function router() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { isLoading: true, routes: { byContext: {}, items: [] } };
  var action = arguments[1];

  switch (action.type) {
    case NAVIGATE:
      if (action.sequence.type === 'start') {
        return _extends({}, state, {
          isLoading: true,
          uri: action.meta.uri
        });
      } else if (action.sequence.type === 'next') {
        return _extends({}, state, action.payload.router, {
          isLoading: false
        });
      }
      break;

    case SET_VIEWPORT_WIDTH:
    case TOGGLE_EXPAND:
      return _extends({}, state, {
        routes: {
          items: state.routes.items,
          byContext: action.payload.routesByContext
        }
      });
      break;

    case UPDATE_SETTINGS:
      if (action.payload.nextPosition) {
        return _extends({}, state, {
          routes: {
            items: state.routes.items,
            byContext: action.payload.nextPosition.routesByContext
          }
        });
      } else {
        return state;
      }
      break;

    default:
      return state;
  }
}

var MOBILE_THRESHOLD = 720;

// TODO REVERT!
var preferredSnapPoint = window.panels && typeof window.panels.preferredSnapPoint === 'number' ? window.panels.preferredSnapPoint : 90;
var viewportWidth = getViewportWidth();
var shouldGoMobile = viewportWidth < MOBILE_THRESHOLD;
var snapPoint = shouldGoMobile ? 0 : preferredSnapPoint;

var RUNTIME_DEFAULT_STATE = {
  maxFullPanelWidth: viewportWidth - snapPoint,
  preferredSnapPoint: preferredSnapPoint,
  snappedAt: 0,
  snapPoint: snapPoint,
  shouldGoMobile: shouldGoMobile,
  x: 0,
  viewportWidth: viewportWidth,
  width: viewportWidth,
  widths: []
};

function runtime() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : RUNTIME_DEFAULT_STATE;
  var action = arguments[1];

  switch (action.type) {
    // TODO normalise
    case MOVE_LEFT:
    case MOVE_TO:
    case SET_X:
      return _extends({}, state, {
        snappedAt: action.payload.snappedAt,
        x: action.payload.x
      });
      break;

    case NAVIGATE:
      if (action.sequence.type === 'next') {
        return _extends({}, state, {
          maxFullPanelWidth: action.payload.runtime.maxFullPanelWidth,
          regions: action.payload.runtime.regions,
          snappedAt: action.payload.runtime.snappedAt,
          width: action.payload.runtime.width,
          widths: action.payload.runtime.widths,
          x: action.payload.runtime.x
        });
      } else {
        return state;
      }
      break;

    case SET_VIEWPORT_WIDTH:
      return _extends({}, state, {
        maxFullPanelWidth: action.payload.maxFullPanelWidth,
        shouldGoMobile: action.payload.shouldGoMobile,
        snapPoint: action.payload.snapPoint,
        viewportWidth: action.payload.viewportWidth,
        width: action.payload.width,
        widths: action.payload.widths,
        x: action.payload.x
      });
      break;

    case TOGGLE_EXPAND:
      return _extends({}, state, {
        width: action.payload.width,
        widths: action.payload.widths,
        x: action.payload.x
      });
      break;

    case UPDATE_SETTINGS:
      if (action.payload.nextPosition) {
        return _extends({}, state, {
          width: action.payload.nextPosition.width,
          widths: action.payload.nextPosition.widths,
          x: action.payload.nextPosition.x
        });
      } else {
        return state;
      }
      break;

    default:
      return state;
  }
}

var rootReducer = redux.combineReducers({
  apps: apps,
  panels: panels,
  router: router,
  runtime: runtime
});

var middleware = redux.applyMiddleware(thunkMiddleware, promiseMiddleware, notify);

function configureStore(state) {
  return redux.createStore(rootReducer, state, middleware);
}

var BaseStyle = (function (props) {
  return React__default.createElement(
    'style',
    null,
    '\n    * {\n      -webkit-overflow-scrolling: touch;\n    }\n    html,body,#root {\n      height:100%;\n      margin:0;\n    }\n    a,button,div,img,input,form,h1,h2,h3,h4,h5,h6,h7,nav,label,li,ol,p,span,svg,ul {\n      box-sizing: border-box;\n      position: relative;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-align: stretch;\n          -ms-flex-align: stretch;\n              align-items: stretch;\n      -ms-flex-negative: 0;\n          flex-shrink: 0;\n      margin: 0;\n      padding: 0;\n    }\n    button,a {\n      background-color: transparent;\n      border: 0;\n      margin: 0;\n      padding: 0;\n      white-space: normal;\n      line-height: inherit;\n      text-align: left;\n      font-family: inherit;\n      font-size: inherit;\n    }\n  '
  );
});

var Teleport = function (_React$Component) {
  inherits(Teleport, _React$Component);

  function Teleport(props, context) {
    classCallCheck(this, Teleport);

    var _this = possibleConstructorReturn(this, (Teleport.__proto__ || Object.getPrototypeOf(Teleport)).call(this, props, context));

    _this.className = 'Teleport-' + uniqueId();
    return _this;
  }

  createClass(Teleport, [{
    key: 'render',
    value: function render() {
      var className = this.className;
      var _props = this.props,
          context = _props.context,
          children = _props.children,
          focus = _props.focus,
          loose = _props.loose,
          onClick = _props.onClick,
          _ref = _props._ref,
          style = _props.style,
          styleActive = _props.styleActive,
          styleActiveHover = _props.styleActiveHover,
          styleHover = _props.styleHover,
          title = _props.title,
          to = _props.to,
          rest = objectWithoutProperties(_props, ['context', 'children', 'focus', 'loose', 'onClick', '_ref', 'style', 'styleActive', 'styleActiveHover', 'styleHover', 'title', 'to']);
      var _context = this.context,
          isActive = _context.isActive,
          navigate = _context.navigate,
          route = _context.route;

      var active = isActive(to, loose);
      var href = normaliseUri('' + route.context + to);

      var inlineStyle = '';
      if (!active && styleHover) {
        inlineStyle = '.' + className + ':hover {' + toCSS(styleHover) + '}';
      }
      if (active && styleActiveHover) {
        inlineStyle = '.' + className + ':hover {' + toCSS(styleActiveHover) + '}';
      }
      var finalStyle = active ? _extends({}, style, styleActive) : style;

      var finalOnClick = function finalOnClick(event) {
        event.preventDefault();
        var preventNavigate = false;

        if (typeof onClick === 'function') {
          preventNavigate = onClick(event);
        }

        if (preventNavigate !== true) {
          navigate(to, focus, context);
        }
      };

      if (_ref) {
        rest.ref = _ref;
      }

      return React__default.createElement(
        'a',
        _extends({}, rest, {
          className: className,
          href: href,
          onClick: finalOnClick,
          style: finalStyle,
          title: title
        }),
        React__default.createElement(
          'style',
          null,
          inlineStyle
        ),
        children
      );
    }
  }]);
  return Teleport;
}(React__default.Component);

Teleport.contextTypes = {
  isActive: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  route: PropTypes.shape({
    context: PropTypes.string.isRequired
  }).isRequired
};

var GoTo = function (_React$Component) {
  inherits(GoTo, _React$Component);

  function GoTo() {
    classCallCheck(this, GoTo);
    return possibleConstructorReturn(this, (GoTo.__proto__ || Object.getPrototypeOf(GoTo)).apply(this, arguments));
  }

  createClass(GoTo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          _ref = _props._ref,
          styleActive = _props.styleActive,
          styleHover = _props.styleHover,
          props = objectWithoutProperties(_props, ['children', 'className', '_ref', 'styleActive', 'styleHover']);


      var inlineStyle = null;
      if (Object.keys(styleHover).length) {
        inlineStyle = React__default.createElement(
          'style',
          null,
          '.' + className + ':hover {' + toCSS(styleHover) + '}'
        );
      }

      if (_ref) {
        props.ref = _ref;
      }

      return React__default.createElement(
        'a',
        _extends({}, props, { className: className, target: '_blank' }),
        inlineStyle,
        children
      );
    }
  }]);
  return GoTo;
}(React__default.Component);

var OnClick = function (_React$Component) {
  inherits(OnClick, _React$Component);

  function OnClick() {
    var _ref2;

    var _temp, _this, _ret;

    classCallCheck(this, OnClick);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = OnClick.__proto__ || Object.getPrototypeOf(OnClick)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {}, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(OnClick, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var props = this.props;


      var manualActive = typeof props.isActive === 'boolean';
      this.setState({
        isActive: manualActive ? props.isActive : false,
        manualActive: manualActive
      });

      this.bindOnClick(props.onClick);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.bindOnClick(nextProps.onClick);

      var manualActive = typeof nextProps.isActive === 'boolean';

      if (manualActive) {
        this.setState({
          isActive: nextProps.isActive,
          manualActive: manualActive
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.onClickTimeout) {
        clearTimeout(this.onClickTimeout);
      }
    }
  }, {
    key: 'bindOnClick',
    value: function bindOnClick(onClick) {
      var _this2 = this;

      var context = this.context;

      /* eslint-disable no-console */

      var finalOnClick = void 0;
      if (typeof onClick === 'function') {
        finalOnClick = function finalOnClick() {
          try {
            onClick();
          } catch (err) {
            var match = err.message.match(/props\.(.+) is not a function/);
            if (match) {
              context.transitionTo(match[1].trim(), true);
            }
          }
        };
      } else {
        var match = void 0;
        if (typeof onClick === 'string') {
          match = onClick.match(/transitionTo\((.+)\)/);
        }
        if (match && typeof context.transitionTo === 'function') {
          finalOnClick = function finalOnClick() {
            return context.transitionTo(match[1].trim());
          };
        } else {
          finalOnClick = function finalOnClick() {
            return console.log(onClick);
          };
        }
      }

      this.onClick = function (event) {
        finalOnClick(event);

        event.stopPropagation();

        if (!_this2.state.manualActive) {
          _this2.setState({
            isActive: true
          });

          _this2.onClickTimeout = setTimeout(function () {
            _this2.setState({
              isActive: false
            });
            _this2.onClickTimeout = null;
          }, _this2.props.styleActiveTimeout);
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var context = this.context;
      var isActive = this.state.isActive;
      /* eslint-disable no-unused-vars */

      var _props = this.props,
          ariaLabel = _props['aria-label'],
          children = _props.children,
          className = _props.className,
          _isActive = _props.isActive,
          isDisabled = _props.isDisabled,
          _ref = _props._ref,
          style = _props.style,
          styleActive = _props.styleActive,
          styleActiveHover = _props.styleActiveHover,
          styleActiveTimeout = _props.styleActiveTimeout,
          styleDisabled = _props.styleDisabled,
          styleHover = _props.styleHover,
          rest = objectWithoutProperties(_props, ['aria-label', 'children', 'className', 'isActive', 'isDisabled', '_ref', 'style', 'styleActive', 'styleActiveHover', 'styleActiveTimeout', 'styleDisabled', 'styleHover']);


      var inlineStyle = null;
      if (!isDisabled) {
        rest.onClick = this.onClick;

        var fClass = className.split(' ')[0];
        if (!isActive && styleHover) {
          inlineStyle = React__default.createElement(
            'style',
            null,
            '.' + fClass + ':hover {' + toCSS(styleHover) + '}'
          );
        }
        if (isActive && styleActiveHover) {
          inlineStyle = React__default.createElement(
            'style',
            null,
            '.' + fClass + ':hover {' + toCSS(styleActiveHover) + '}'
          );
        }
      }

      var finalStyle = _extends({
        cursor: 'pointer'
      }, style);
      if (isDisabled) {
        finalStyle = _extends({}, finalStyle, {
          cursor: 'default'
        }, styleDisabled);
      } else if (isActive) {
        finalStyle = _extends({}, finalStyle, styleActive);
      }

      if (_ref) {
        rest.ref = _ref;
      }

      return React__default.createElement(
        'button',
        _extends({}, rest, {
          'aria-label': ariaLabel ? context.i18n ? context.i18n.t(ariaLabel) : ariaLabel : undefined,
          className: className,
          style: finalStyle }),
        inlineStyle,
        children
      );
    }
  }]);
  return OnClick;
}(React__default.Component);

OnClick.contextTypes = {
  i18n: PropTypes.shape({
    t: PropTypes.func.isRequired
  }),
  transitionTo: PropTypes.func
};
OnClick.defaultProps = {
  styleActiveTimeout: 1000
};

function createGroup(name, groupStyle) {
  var Group = function (_React$Component) {
    inherits(Group, _React$Component);

    function Group(props, context) {
      classCallCheck(this, Group);

      var _this = possibleConstructorReturn(this, (Group.__proto__ || Object.getPrototypeOf(Group)).call(this, props, context));

      _this.localClassName = name + '-' + uniqueId();
      return _this;
    }

    createClass(Group, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            children = _props.children,
            moreClassName = _props.className,
            goTo = _props.goTo,
            style = _props.style,
            teleportTo = _props.teleportTo,
            props = objectWithoutProperties(_props, ['children', 'className', 'goTo', 'style', 'teleportTo']);
        var localClassName = this.localClassName;
        var pages = this.context.pages;


        var finalStyle = _extends({}, groupStyle, style);

        var className = localClassName;
        if (typeof moreClassName === 'string') {
          className += ' ' + moreClassName;
        }

        var Base = void 0;
        if (teleportTo) {
          Base = Teleport;
          props.to = teleportTo;
        } else if (goTo) {
          Base = GoTo;
          props.href = goTo;
        } else if ((props.onClick || props.onMouseDown || props.onMouseUp) && !props.noButton) {
          Base = OnClick;
        } else {
          var isDisabled = props.isDisabled,
              noButton = props.noButton,
              _ref = props._ref,
              styleDisabled = props.styleDisabled,
              styleActive = props.styleActive,
              styleActiveHover = props.styleActiveHover,
              styleActiveTimeout = props.styleActiveTimeout,
              styleHover = props.styleHover,
              rest = objectWithoutProperties(props, ['isDisabled', 'noButton', '_ref', 'styleDisabled', 'styleActive', 'styleActiveHover', 'styleActiveTimeout', 'styleHover']);


          var inlineStyle = null;
          if (isDisabled) {
            if (styleDisabled) {
              finalStyle = _extends({}, finalStyle, styleDisabled);
            }
          } else {
            if (Object.keys(styleHover).length) {
              inlineStyle = React__default.createElement(
                'style',
                null,
                '.' + localClassName + ':hover {' + toCSS(styleHover) + '}'
              );
            }
          }

          return React__default.createElement(
            'div',
            _extends({}, rest, { className: className, ref: _ref, style: finalStyle }),
            inlineStyle,
            children
          );
        }

        if (pages && pages.isSelecting) {
          props.onClick = function (event) {
            if (event) {
              event.preventDefault();
            }
            return true;
          };
        }

        return React__default.createElement(
          Base,
          _extends({}, props, { className: className, style: finalStyle }),
          children
        );
      }
    }]);
    return Group;
  }(React__default.Component);

  Group.contextTypes = {
    pages: PropTypes.shape({
      isSelecting: PropTypes.bool
    })
  };

  Group.defaultProps = {
    className: '',
    style: {},
    styleActive: {},
    styleHover: {}
  };

  Group.displayName = name;

  return Group;
}

var Horizontal = createGroup('Horizontal', { flexDirection: 'row' });

var animation = '@keyframes scaleout {\n  0% {\n    transform: scale(0.0);\n    -webkit-transform: scale(0.0);\n  } 100% {\n    transform: scale(1.0);\n    -webkit-transform: scale(1.0);\n    opacity: 0;\n  }\n}';

var Knocking = function Knocking(_ref) {
  var dataBlock = _ref['data-block'],
      size = _ref.size,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style;

  var finalStyle = _extends({
    animation: 'scaleout 1.0s infinite linear',
    backgroundColor: style.color,
    borderRadius: size,
    height: size,
    WebkitAnimation: 'scaleout 1.0s infinite linear',
    width: size
  }, style);

  return React__default.createElement(
    Horizontal,
    { 'data-block': dataBlock, style: finalStyle },
    React__default.createElement(
      'style',
      null,
      animation
    )
  );
};

Knocking.defaultProps = {
  style: {
    color: '#323232'
  },
  size: 32
};

var ErrorBoundary = function (_React$Component) {
  inherits(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ErrorBoundary);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hasError: false }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ErrorBoundary, [{
    key: 'componentDidCatch',
    value: function componentDidCatch(error, info) {
      // Display fallback UI
      this.setState({ hasError: true });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.hasError) {
        return React__default.createElement(
          'div',
          null,
          ':/'
        );
      }

      return this.props.children;
    }
  }]);
  return ErrorBoundary;
}(React__default.Component);

var Route$1 = function (_React$Component) {
  inherits(Route, _React$Component);

  function Route() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Route.__proto__ || Object.getPrototypeOf(Route)).call.apply(_ref, [this].concat(args))), _this), _this.isActive = function (path) {
      var _this$props = _this.props,
          route = _this$props.route,
          router = _this$props.router,
          routeIndex = _this$props.routeIndex;


      var routeAfterContext = router.routes.items[routeIndex + 1];
      return routeAfterContext && normaliseUri('' + route.context + path) === routeAfterContext;
    }, _this.navigate = function (toUri, focus, context) {
      var raw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return _this.props.navigate(raw ? toUri : '' + _this.props.route.context + toUri, focus, context);
    }, _this.toggleExpand = function () {
      return _this.props.toggleExpand(_this.props.route.context);
    }, _this.updateSettings = function (settings) {
      return _this.props.updateSettings(_this.props.route.context, settings);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Route, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var isActive = this.isActive,
          navigate = this.navigate,
          toggleExpand = this.toggleExpand,
          updateSettings = this.updateSettings;
      var _props = this.props,
          isContext = _props.isContext,
          isFocus = _props.isFocus,
          panel = _props.panel,
          route = _props.route,
          routeIndex = _props.routeIndex,
          router = _props.router;


      return {
        isActive: isActive,
        isContext: isContext,
        isFocus: isFocus,
        navigate: navigate,
        panel: panel,
        route: route,
        routeIndex: routeIndex,
        router: router,
        toggleExpand: toggleExpand,
        updateSettings: updateSettings
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var isActive = this.isActive,
          navigate = this.navigate,
          props = this.props,
          toggleExpand = this.toggleExpand,
          updateSettings = this.updateSettings;


      var res = void 0;

      if (props.panel.isCustom) {
        res = React__default.createElement(CustomRoute, props);
      } else {
        var Type = props.Type,
            width = props.width,
            rest = objectWithoutProperties(props, ['Type', 'width']);

        // the order below is correct, width can be overwritten but panels shouldn't be

        res = React__default.createElement(Type, _extends({
          width: width
        }, props.panel.props, {
          panels: _extends({}, rest, {
            isActive: isActive,
            navigate: navigate,
            toggleExpand: toggleExpand,
            updateSettings: updateSettings
          })
        }));
      }

      return React__default.createElement(
        ErrorBoundary,
        null,
        res
      );
    }
  }]);
  return Route;
}(React__default.Component);

var routeShape = PropTypes.shape({
  app: PropTypes.string.isRequired,
  context: PropTypes.string.isRequired,
  panelId: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,
  width: PropTypes.number.isRequired
});

Route$1.childContextTypes = {
  isActive: PropTypes.func.isRequired,
  isContext: PropTypes.bool,
  isFocus: PropTypes.bool,
  navigate: PropTypes.func.isRequired,
  panel: PropTypes.object.isRequired,
  route: routeShape.isRequired,
  routeIndex: PropTypes.number.isRequired,
  router: PropTypes.shape({
    routes: PropTypes.shape({
      byContext: PropTypes.objectOf(routeShape),
      items: PropTypes.arrayOf(PropTypes.string)
    }),
    uri: PropTypes.string.isRequired
  }),
  toggleExpand: PropTypes.func.isRequired,
  updateSettings: PropTypes.func.isRequired
};

var CustomRoute = function (_React$Component2) {
  inherits(CustomRoute, _React$Component2);

  function CustomRoute() {
    var _ref2;

    var _temp2, _this2, _ret2;

    classCallCheck(this, CustomRoute);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = possibleConstructorReturn(this, (_ref2 = CustomRoute.__proto__ || Object.getPrototypeOf(CustomRoute)).call.apply(_ref2, [this].concat(args))), _this2), _this2.state = {}, _this2.subscribe = function (onChange) {
      return _this2.onChange = onChange;
    }, _temp2), possibleConstructorReturn(_this2, _ret2);
  }

  createClass(CustomRoute, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var isActive = this.isActive,
          navigate = this.navigate,
          toggleExpand = this.toggleExpand,
          updateSettings = this.updateSettings;
      var _props2 = this.props,
          isContext = _props2.isContext,
          isFocus = _props2.isFocus,
          panel = _props2.panel,
          route = _props2.route,
          routeIndex = _props2.routeIndex,
          router = _props2.router,
          store = _props2.store,
          Type = _props2.Type;


      var typeProps = {
        isActive: isActive,
        isContext: isContext,
        isFocus: isFocus,
        navigate: navigate,
        panel: panel,
        route: route,
        routeIndex: routeIndex,
        router: router,
        store: store,
        toggleExpand: toggleExpand,
        updateSettings: updateSettings
      };

      try {
        this.onDestroy = Type(this.$el, typeProps, this.subscribe);
      } catch (error) {
        console.error('panels:route', error);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props3 = this.props,
          panel = _props3.panel,
          route = _props3.route,
          routeIndex = _props3.routeIndex,
          router = _props3.router,
          type = _props3.type;


      if (prevProps.type !== type) {
        this.componentWillUnmount();
        this.componentDidMount();
      } else if (typeof this.onChange === 'function' && (prevProps.panel !== panel || prevProps.route !== route || prevProps.routeIndex !== routeIndex || prevProps.router !== router)) {
        this.onChange({
          panel: panel,
          route: route,
          routeIndex: routeIndex,
          router: router
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (typeof this.onDestroy === 'function') {
        this.onDestroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var props = this.props,
          state = this.state;


      return React__default.createElement(
        'div',
        {
          ref: function ref($el) {
            _this3.$el = $el;
          },
          style: _extends({
            backgroundColor: state.error && '#ff5959',
            height: '100%',
            overflowY: 'auto',
            width: props.width,
            zIndex: props.zIndex
          }, props.style)
        },
        state.error && React__default.createElement(
          'pre',
          { style: { color: '#ffffff', overflowX: 'scroll', padding: 10 } },
          state.error.stack
        )
      );
    }
  }]);
  return CustomRoute;
}(React__default.Component);

var DEBOUNCE = 250;
var LOADING_SIZE = 100;
var LOADING_OFFSET = LOADING_SIZE / -2;
var REBOUND = 500;

var LaunchpadRuntime = function (_Component) {
  inherits(LaunchpadRuntime, _Component);

  function LaunchpadRuntime() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, LaunchpadRuntime);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = LaunchpadRuntime.__proto__ || Object.getPrototypeOf(LaunchpadRuntime)).call.apply(_ref, [this].concat(args))), _this), _this.onVisibilityChange = function () {
      if (document.visibilityState === 'hidden') {
        window.removeEventListener('resize', _this.setViewportWidth);
        window.removeEventListener('orientationchange', _this.setViewportWidth);
      } else {
        setTimeout(function () {
          _this.setViewportWidth();
          window.addEventListener('resize', _this.setViewportWidth, false);
          window.addEventListener('orientationchange', _this.setViewportWidth, false);
        }, REBOUND);
      }
    }, _this.setViewportWidth = debounce(function () {
      return _this.props.setViewportWidth(getViewportWidth());
    }, DEBOUNCE), _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(LaunchpadRuntime, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.setViewportWidth, false);
      window.addEventListener('orientationchange', this.setViewportWidth, false);
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      this.ensureDefault();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var props = this.props;


      if (props.mainPanel && props.mainPanel.title) {
        window.document.title = props.mainPanel.title;
      }

      this.ensureDefault();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.setViewportWidth);
      window.removeEventListener('orientationchange', this.setViewportWidth);
    }
  }, {
    key: 'ensureDefault',
    value: function ensureDefault() {
      var props = this.props;

      if (props.launchpadPanel && !props.mainPanel) {
        props.navigate(props.launchpadRoute.context + '/' + props.launchpadPanel.default);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          dockedApp = _props.dockedApp,
          dockedPanel = _props.dockedPanel,
          dockedRoute = _props.dockedRoute,
          dockedRouteIndex = _props.dockedRouteIndex,
          mainApp = _props.mainApp,
          mainPanel = _props.mainPanel,
          mainRoute = _props.mainRoute,
          launchpadApp = _props.launchpadApp,
          launchpadPanel = _props.launchpadPanel,
          launchpadRoute = _props.launchpadRoute,
          navigate = _props.navigate,
          router = _props.router,
          runtime = _props.runtime,
          updateSettings = _props.updateSettings;


      var docked = dockedPanel && React__default.createElement(Route$1, {
        key: 'docked-' + (dockedPanel.dockLeft ? 'left' : 'right'),
        navigate: navigate,
        panel: dockedPanel,
        route: dockedRoute,
        routeIndex: dockedRouteIndex,
        router: router,
        store: dockedApp.store,
        Type: dockedApp.types[dockedPanel.type],
        updateSettings: updateSettings,
        width: dockedRoute.width
      });

      var mainWidth = runtime.viewportWidth - (dockedRoute && dockedRoute.width || 0);

      return React__default.createElement(
        'div',
        {
          ref: function ref($e) {
            return _this2.$runtime = $e;
          },
          style: {
            flexDirection: 'column',
            height: '100%',
            overflow: 'hidden',
            width: '100%'
          }
        },
        React__default.createElement(BaseStyle, null),
        launchpadPanel && React__default.createElement(Route$1, {
          navigate: navigate,
          panel: launchpadPanel,
          route: launchpadRoute,
          routeIndex: 0,
          router: router,
          store: launchpadApp.store,
          style: _extends({
            height: launchpadPanel.height || 0
          }, launchpadPanel.style),
          Type: launchpadApp.types[launchpadPanel.type],
          updateSettings: updateSettings,
          width: runtime.viewportWidth
        }),
        React__default.createElement(
          'div',
          {
            style: {
              flexDirection: 'row',
              height: 'calc(100% - ' + (launchpadPanel && launchpadPanel.height || 0) + 'px)',
              overflow: 'hidden',
              width: '100vw'
            }
          },
          dockedPanel && dockedPanel.dockLeft && docked,
          mainPanel && React__default.createElement(Route$1, {
            key: 'main',
            navigate: navigate,
            panel: mainPanel,
            route: mainRoute,
            routeIndex: 1,
            router: router,
            store: mainApp.store,
            Type: mainApp.types[mainPanel.type],
            updateSettings: updateSettings,
            width: mainWidth
          }),
          dockedPanel && !dockedPanel.dockLeft && docked
        ),
        router.isLoading ? React__default.createElement(
          'div',
          {
            style: {
              flexDirection: 'column',
              justifyContent: 'center',
              position: 'absolute',
              left: LOADING_OFFSET,
              top: LOADING_OFFSET
            }
          },
          React__default.createElement(Knocking, { size: LOADING_SIZE })
        ) : null
      );
    }
  }]);
  return LaunchpadRuntime;
}(React.Component);

function mapStateToProps(_ref2, props) {
  var apps = _ref2.apps,
      panels = _ref2.panels,
      runtime = _ref2.runtime,
      router = _ref2.router;

  var launchpadRoute = router.routes.byContext[router.routes.items[0]];
  var mainRoute = router.routes.byContext[router.routes.items[1]];
  var dockedRoute = void 0;
  var dockedRouteIndex = void 0;
  if (router.routes.items.length > 2) {
    dockedRouteIndex = router.routes.items.length - 1;
    dockedRoute = router.routes.byContext[router.routes.items[dockedRouteIndex]];
  }

  var dockedPanel = dockedRoute && panels.byId[dockedRoute.panelId];
  var mainPanel = mainRoute && panels.byId[mainRoute.panelId];

  return {
    dockedApp: dockedRoute && apps.byName[dockedRoute.app],
    dockedPanel: dockedPanel,
    dockedRoute: dockedRoute,
    dockedRouteIndex: dockedRouteIndex,

    focusPanel: dockedPanel || mainPanel, // <-- TODO will change with what's open & focused, e.g. TOC

    mainApp: mainRoute && apps.byName[mainRoute.app],
    mainPanel: mainPanel,
    mainRoute: mainRoute,

    launchpadApp: launchpadRoute && apps.byName[launchpadRoute.app],
    launchpadPanel: launchpadRoute && panels.byId[launchpadRoute.panelId],
    launchpadRoute: launchpadRoute,

    router: router,
    runtime: runtime
  };
}

var mapDispatchToProps = {
  navigate: navigate,
  setViewportWidth: setViewportWidth,
  updateSettings: updateSettings
};
var Launchpad = reactRedux.connect(mapStateToProps, mapDispatchToProps)(LaunchpadRuntime);

function easeOutCubic(currentIteration, startValue, changeInValue, totalIterations) {
  return changeInValue * (Math.pow(currentIteration / totalIterations - 1, 3) + 1) + startValue;
}

var FUNCTIONS = Object.freeze({
  easeOutCubic: easeOutCubic
});

function snap($el, to, scroll, _ref) {
  var _ref$delay = _ref.delay,
      delay = _ref$delay === undefined ? 10 : _ref$delay,
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 75 : _ref$duration,
      _ref$fn = _ref.fn,
      fn = _ref$fn === undefined ? 'easeOutCubic' : _ref$fn,
      _ref$step = _ref.step,
      step = _ref$step === undefined ? 5 : _ref$step;

  var currentTime = 0;
  var next = FUNCTIONS[fn] || easeOutCubic;
  var start = $el[scroll];
  var change = to - start;

  var animate = function animate() {
    currentTime += step;

    $el[scroll] = next(currentTime, start, change, duration);

    if (currentTime < duration) {
      requestAnimationFrame(animate);
    }
  };

  setTimeout(animate, delay);
}

function snapX($el, to) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  snap($el, to, 'scrollLeft', options);
}

var ArrowLeft = function ArrowLeft(props) {
  return React__default.createElement(
    "svg",
    { height: "10px", viewBox: "0 0 10 10", width: "10px" },
    React__default.createElement("path", { fill: props.fill, d: "M6.826,10.011c0.236,0,0.473-0.083,0.664-0.252C7.903,9.392,7.941,8.76,7.574,8.347L4.603,5l2.971-3.347 C7.94,1.24,7.903,0.608,7.49,0.241C7.076-0.125,6.444-0.087,6.078,0.325L2.517,4.336c-0.336,0.379-0.336,0.949,0,1.328 l3.561,4.011C6.276,9.897,6.55,10.011,6.826,10.011z" })
  );
};
ArrowLeft.defaultProps = {
  fill: '#FFFFFF'
};

var DIAMETER = 40;

var MoveLeft = function MoveLeft(_ref) {
  var onClick = _ref.onClick,
      snapPoint = _ref.snapPoint;
  return React__default.createElement(
    'div',
    {
      onClick: onClick,
      style: {
        alignItems: 'center',
        backgroundColor: '#00ADEE',
        borderRadius: DIAMETER,
        bottom: 32,
        cursor: 'pointer',
        height: DIAMETER,
        justifyContent: 'center',
        left: snapPoint - DIAMETER / 2,
        position: 'fixed',
        width: DIAMETER,
        zIndex: 100000
      }
    },
    React__default.createElement(ArrowLeft, null)
  );
};

var supports = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      supports = true;
    }
  });
  window.addEventListener('test', null, opts);
} catch (e) {}

var supportsPassiveEvents = supports;

var DEBOUNCE$1 = 250;
var LOADING_SIZE$1 = 100;
var LOADING_OFFSET$1 = LOADING_SIZE$1 / -2;
var REBOUND$1 = 500;

var scrollEventOptions = supportsPassiveEvents ? { passive: true } : false;

var style = {
  height: '100%',
  overflowX: 'auto',
  overflowY: 'hidden',
  width: '100vw'
};

var Runtime = function (_React$Component) {
  inherits(Runtime, _React$Component);

  function Runtime() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Runtime);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Runtime.__proto__ || Object.getPrototypeOf(Runtime)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      autoScroll: null
    }, _this.onVisibilityChange = function () {
      if (document.visibilityState === 'hidden') {
        if (_this.props.snap) {
          _this.$runtime.removeEventListener('scroll', _this.setX);
        }
        window.removeEventListener('resize', _this.setViewportWidth);
        window.removeEventListener('orientationchange', _this.setViewportWidth);
      } else {
        setTimeout(function () {
          if (_this.props.snap) {
            _this.$runtime.addEventListener('scroll', _this.setX, scrollEventOptions);
          }
          window.addEventListener('resize', _this.setViewportWidth, false);
          window.addEventListener('orientationchange', _this.setViewportWidth, false);
        }, REBOUND$1);
      }
    }, _this.scrollRuntime = function (_ref2) {
      var x = _ref2.x;
      var autoScroll = _this.state.autoScroll;


      if (_this.$runtime && autoScroll) {
        _this.$runtime.scrollLeft = autoScroll.from + x;
      }
      return null;
    }, _this.setViewportWidth = debounce(function () {
      _this.props.setViewportWidth(getViewportWidth());
    }, DEBOUNCE$1), _this.setX = debounce(function (event) {
      if (!_this.props.snap) return;

      if (_this.state.autoScroll) {
        _this.setState({
          autoScroll: null
        });
      }

      var nextX = _this.$runtime.scrollLeft;
      if (Math.abs(_this.props.runtime.x - nextX) > 5) {
        _this.props.setX(nextX);
      }
    }, DEBOUNCE$1), _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Runtime, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.snap) {
        this.$runtime.addEventListener('scroll', this.setX, scrollEventOptions);
      }
      window.addEventListener('resize', this.setViewportWidth, false);
      window.addEventListener('orientationchange', this.setViewportWidth, false);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var props = this.props;


      if (props.focusPanel) {
        window.document.title = props.focusPanel.title || props.focusPanel.type;
      }

      if (props.snap && prevProps.runtime.x !== props.runtime.x) {
        snapX(this.$runtime, props.runtime.x);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.snap) {
        this.$runtime.removeEventListener('scroll', this.setX);
      }
      window.removeEventListener('resize', this.setViewportWidth);
      window.removeEventListener('orientationchange', this.setViewportWidth);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          apps = _props.apps,
          canMoveLeft = _props.canMoveLeft,
          focusPanel = _props.focusPanel,
          moveLeft = _props.moveLeft,
          navigate = _props.navigate,
          panels = _props.panels,
          router = _props.router,
          runtime = _props.runtime,
          snap = _props.snap,
          toggleExpand = _props.toggleExpand,
          updateSettings = _props.updateSettings,
          visibleRoutes = _props.visibleRoutes;


      var runtimeStyle = focusPanel ? _extends({}, style, focusPanel.styleBackground) : style;

      return React__default.createElement(
        Horizontal,
        { _ref: function _ref($e) {
            return _this2.$runtime = $e;
          }, style: runtimeStyle },
        React__default.createElement(BaseStyle, null),
        canMoveLeft && snap && React__default.createElement(MoveLeft, { onClick: moveLeft, snapPoint: runtime.snapPoint }),
        React__default.createElement(
          Horizontal,
          {
            style: {
              flexDirection: 'row',
              height: '100%',
              overflowY: 'hidden',
              paddingLeft: runtime.snapPoint,
              width: runtime.width,
              willChange: 'scroll-position'
            }
          },
          visibleRoutes.map(function (context, i) {
            var route = router.routes.byContext[context];
            var app = apps[route.app];
            var panel = panels[route.panelId];

            return React__default.createElement(Route$1, {
              isContext: i >= router.context,
              isFocus: i === router.focus,
              key: i + '-' + app.name + '-' + panel.type,
              navigate: navigate,
              panel: panel,
              route: route,
              routeIndex: i,
              router: router,
              store: app.store,
              toggleExpand: toggleExpand,
              Type: app.types[panel.type],
              updateSettings: updateSettings,
              width: route.width,
              zIndex: router.routes.items.length - i
            });
          })
        ),
        router.isLoading ? React__default.createElement(
          Horizontal,
          {
            style: {
              justifyContent: 'center',
              left: router.routes.items.length ? LOADING_OFFSET$1 : LOADING_OFFSET$1 - runtime.snapPoint,
              marginTop: LOADING_OFFSET$1
            }
          },
          React__default.createElement(Knocking, { size: LOADING_SIZE$1 })
        ) : null
      );
    }
  }]);
  return Runtime;
}(React__default.Component);

var getFocusPanel = function getFocusPanel(_ref3) {
  var panels = _ref3.panels,
      router = _ref3.router;

  var focusRoute = router.routes.byContext[router.routes.items[router.focus]];
  return focusRoute && panels.byId[focusRoute.panelId];
};

var getCanMoveLeft = function getCanMoveLeft(_ref4) {
  var runtime = _ref4.runtime;
  return !runtime.shouldGoMobile && runtime.x > 0;
};

function mapStateToProps$1(state, props) {
  return {
    apps: state.apps.byName,
    canMoveLeft: getCanMoveLeft(state),
    focusPanel: getFocusPanel(state),
    panels: state.panels.byId,
    router: state.router,
    runtime: state.runtime,
    visibleRoutes: state.router.routes.items.filter(function (r) {
      return state.router.routes.byContext[r].isVisible;
    })
  };
}

var mapDispatchToProps$1 = {
  moveLeft: moveLeft,
  navigate: navigate,
  setViewportWidth: setViewportWidth,
  setX: setX,
  toggleExpand: toggleExpand,
  updateSettings: updateSettings
};
var Trails = reactRedux.connect(mapStateToProps$1, mapDispatchToProps$1)(Runtime);



var runtimes = Object.freeze({
	Launchpad: Launchpad,
	Trails: Trails
});

function history(store) {
  var navigateHandler = function navigateHandler() {
    return store.dispatch(navigate(location.href));
  };

  window.addEventListener('popstate', navigateHandler);

  var unsubscribe = store.subscribe(function () {
    var uri = store.getState().router.uri;


    if (uri !== location.href) {
      window.history.pushState(null, null, uri);
    }
  });

  return function historyOff() {
    window.removeEventListener('popstate', navigateHandler);
    unsubscribe();
  };
}

function runtimeRender(configureStore) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$snap = _ref.snap,
      snap = _ref$snap === undefined ? true : _ref$snap,
      _ref$runtime = _ref.runtime,
      runtime = _ref$runtime === undefined ? 'Trails' : _ref$runtime,
      initialState = objectWithoutProperties(_ref, ['snap', 'runtime']);

  var store = configureStore({
    router: {
      routes: {
        byContext: {},
        items: []
      },
      parsers: initialState.router && initialState.router.parsers
    }
  });
  store.dispatch(navigate(location.href));

  history(store);

  var Runtime = runtimes[runtime];

  reactDom.render(React__default.createElement(
    reactRedux.Provider,
    { store: store },
    React__default.createElement(Runtime, { snap: snap })
  ), document.getElementById('root'));

  return store;
}

var render$1 = function render(props) {
  return runtimeRender(configureStore, props);
};

if (!window.panelsDontAutoLoad) {
  window.addEventListener('load', function () {
    render$1(window.panels);
  });
}

exports.render = render$1;